export default __webpack_public_path__ + "static/media/AnittaElizabathuBenny.d84b0ae7.jpg";